<app-top-navbar [title]="'profiles.update_confirmation.back'| translate">

  <a class="top-bar-link"
     [routerLink]="['../..', 'member']">
    <i class="icon icon-chevron-left"></i>
  </a>
</app-top-navbar>

<div class="wrapper page-update-confirmation">

  <div class="content">
    <app-alert alertType="info"
               [withIcon]="true">
      {{ 'profiles.update_confirmation.notice' | translate }}
    </app-alert>
  </div>

  <app-loyalty-club-footer/>
</div>
